export default __webpack_public_path__ + "static/media/eolt_logo.69abea68.svg";